import { useAuthStore } from '@stores/auth'
import { useCustomerStore } from '@stores/me/customer'
import { useKidStore } from '@stores/kid'
import { useDisciplineStore } from '@stores/discipline'
import { useSettingsStore } from '@stores/settings'
import { useListsStore } from '@stores/lists'
import { useBookingStore } from '@stores/booking'
import { usePadStore } from '@stores/pad'

interface LogOutOptions {
  navigate?: boolean
}

interface LogOutReturn {
  logout: (options?: LogOutOptions) => Promise<void>
}

export const useLogOut = (): LogOutReturn => {
  const authStore = useAuthStore()
  const customerStore = useCustomerStore()
  const kidStore = useKidStore()
  const disciplineStore = useDisciplineStore()
  const bookingStore = useBookingStore()
  const settingsStore = useSettingsStore()
  const listsStore = useListsStore()
  const padStore = usePadStore()

  const logout = async (options?: LogOutOptions): Promise<void> => {
    const shouldNavigate = options?.navigate ?? true

    customerStore.clear()
    kidStore.clear()
    disciplineStore.clear()
    bookingStore.clear()
    settingsStore.clear()
    listsStore.clear()
    padStore.clear()

    if (!shouldNavigate) {
      authStore.reset()
      return
    }

    await authStore.logout()
  }

  return {
    logout,
  }
}
